import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { LI, UL, P } from "../../../../../../AbstractElements";
import GroupMembersModal from "./GroupMembersModal";
import CreateNewGroupModal from "./CreateNewGroupModal"; // Import the create group modal
import {
  changeGroupChat,
  setChats,
  setLoading,
} from "../../../../../../ReduxToolkit/Reducers/ChatReducer";
import http from "../../../../../../services/http";
import { getAPIURLAWS } from "../../../../../../services/helper";
import { dynamicImage } from "../../../../../../Utils";
import { Button } from "reactstrap";
import GroupEdit from "./GroupEdit";

const api_url = getAPIURLAWS();

export default function GroupsTabPane() {
  const { isLoading, groups, selectedGroup, chats } = useSelector(
    (state) => state.chat
  );
  const dispatch = useDispatch();
  const [Group, setSelectedGroup] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [createModalOpen, setCreateModalOpen] = useState(false); // For toggling the create group modal

  const toggleModal = () => setModalOpen(!modalOpen);
  const toggleCreateModal = () => setCreateModalOpen(!createModalOpen); // Toggle for the create group modal

  const fetchGroupChat = async (group) => {
    try {
      dispatch(setLoading(true));
      const { data: group_chat } = await http.get(
        `${api_url}/chats/group/chat/${group.groupId}`
      );

      let current_chats = [
        group_chat,
        ...chats.filter((c) => c.id !== `GROUP-${group.groupId}`),
      ];

      dispatch(setLoading(false));
      dispatch(setChats(current_chats));
      dispatch(changeGroupChat(group.groupId));
      setSelectedGroup(group); // Set the current active group
    } catch (e) {
      dispatch(setLoading(false));
      console.error("Error while fetching group chat", e);
    }
  };

  const handleGroupSettingsClick = (group) => {
    setSelectedGroup(group);
    toggleModal();
  };

  return (
    <>
      <Button
        color="primary"
        className="create-group-btn"
        onClick={toggleCreateModal} // Open the create group modal
      >
        + Create Group
      </Button>
      {groups && groups.length > 0 ? (
        <UL className="chats-user simple-list">
          {groups.map((group) => (
            <LI
              key={group.groupId}
              className={`group-item ${
                selectedGroup?.groupId === group.groupId ? "active" : ""
              }`}
            >
              <div className="group-content d-flex align-items-center justify-content-between ">
                <div
                  onClick={() => fetchGroupChat(group)}
                  className="d-flex align-items-center w-full"
                >
                  <img
                    src={dynamicImage("group-icon.png")}
                    alt="Group Icon"
                    className="group-icon rounded-circle"
                  />
                  <div className="group-info ms-3 text-left">
                    <h6 className="group-name mb-1">{group.groupName}</h6>
                    <P className="text-muted small mb-0">{`${group.users.length} Members`}</P>
                  </div>
                </div>
                <GroupEdit className={"ml-auto"} id={group?.groupId} />
              </div>
            </LI>
          ))}
        </UL>
      ) : (
        <div className="text-center">{"No Groups Present"}</div>
      )}
      <style jsx>{`
        .create-group-btn {
          display: block;
          width: 100%;
          margin: 15px 0;
        }
        .group-item {
          border-bottom: 1px solid #ddd;
          padding: 12px 15px;
          margin-bottom: 5px;
          cursor: pointer;
          transition: background-color 0.2s ease;
          border-radius: 8px;
        }
        .group-item.active,
        .group-item:hover {
          background-color: #f0f0f0;
        }
        .group-content {
          display: flex;
          align-items: center;
          justify-content: space-between;
        }
        .group-icon {
          width: 40px;
          height: 40px;
        }
        .group-info {
          flex: 1;
        }
        .group-name {
          font-size: 16px;
          font-weight: 600;
          color: #333;
        }
        .settings-icon {
          cursor: pointer;
          font-size: 18px;
        }
      `}</style>
      {selectedGroup && (
        <GroupMembersModal
          isOpen={modalOpen}
          toggle={toggleModal}
          group={Group}
        />
      )}
      <CreateNewGroupModal
        isOpen={createModalOpen}
        toggle={toggleCreateModal}
      />{" "}
      {/* Render the create group modal */}
    </>
  );
}
